module.exports = __webpack_public_path__ + "static/media/kofi.3637c9c3.png";